import './component.scss';
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import './images/strength_icon.svg'

const app = Application.start()

app.register('refosumu-company-show-strengths', class extends Controller {
  static targets = ["sliderSp"]

  connect() {
    // window.load イベントを待ってから初期化
    if (document.readyState === 'complete') {
      this.initializeSliders()
    } else {
      window.addEventListener('load', () => {
        this.initializeSliders()
      })
    }
  }

  initializeSliders() {
    const SP_PER_PAGE = 1;

    const SLIDER_CONFIG = {
      speed: 800,
      perPage: SP_PER_PAGE,
      perMove: SP_PER_PAGE,
      gap: '12px',
      pagination: false,
      arrows: true,
      focus: 'center',
    };

    // SP用スライダー初期化（PC表示はスライダーではなく通常のカード表示）
    if (this.hasSliderSpTarget) {
      const spSplide = new Splide(this.sliderSpTarget, SLIDER_CONFIG);
      spSplide.mount();
    }
  }

  // もっと見るボタンクリック時の処理
  toggle(event) {
    const card = event.target.closest('.company-show-strengths__strength-card')
    const content = card.querySelector('[data-refosumu-company-show-strengths-target="content"]')
    const toggleText = card.querySelector('[data-refosumu-company-show-strengths-target="toggleText"]')
    
    const isExpanded = content.classList.contains('is-expanded')
    
    if (isExpanded) {
      // 折りたたむ
      content.classList.remove('is-expanded')
      toggleText.textContent = 'もっと見る'
    } else {
      // 展開する
      content.classList.add('is-expanded')
      toggleText.textContent = '閉じる'
    }
  }
})
